export const REVIEW_REQUESTS_LIST_REQUEST =
  "REVIEW_REQUESTS_LIST_REQUEST";

export const REVIEW_REQUESTS_LIST_RESPONSE =
  "REVIEW_REQUESTS_LIST_RESPONSE";

export const APPROVED_PRODUCTS_LIST_REQUEST =
  "APPROVED_PRODUCTS_LIST_REQUEST";

export const APPROVED_PRODUCTS_LIST_RESPONSE =
  "APPROVED_PRODUCTS_LIST_RESPONSE";

export const APPROVE_PRODUCT_REQUEST = "APPROVE_PRODUCT_REQUEST";

export const REJECT_PRODUCT_REQUEST = "REJECT_PRODUCT_REQUEST";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";

export const PRODUCT_DETAILS_RESPONSE = "PRODUCT_DETAILS_RESPONSE";

export const PRODUCT_VERSION_DETAILS_REQUEST =
  "PRODUCT_VERSION_DETAILS_REQUEST";

export const PRODUCT_VERSION_DETAILS_RESPONSE =
  "PRODUCT_VERSION_DETAILS_RESPONSE";
